module.exports = __webpack_public_path__ + "static/media/ice-demon.230e16ab.png";